import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import {
  getDisplayNameForIntegrationType,
  trackIntegrationPageAddLinkEvent,
} from '@modules/integrationsV2/utils';
import { Button, Stack, Typography } from '@mui/material';
import { IntegrationType } from 'generated/graphql';

interface NoIntegrationsFoundForTypeProps {
  integrationType: IntegrationType;
}

export const NoIntegrationsFoundForType = ({
  integrationType,
}: NoIntegrationsFoundForTypeProps) => {
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const isUserOrAccountType =
    integrationType === IntegrationType.User ||
    integrationType === IntegrationType.Account;

  const onClickAddIntegration = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        isAddDrawerOpen: true,
        integrationTypeFilterInDrawer: integrationType,
      },
    });
    trackIntegrationPageAddLinkEvent({
      eventName: 'Link Integrations - Add New Integration Type Button Clicked',
      integrationType,
    });
  };

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Typography variant="body2" color="text.secondary">
        You haven't added any{' '}
        {getDisplayNameForIntegrationType(integrationType)} integrations yet,
        connect one to analyse feedback
        {isUserOrAccountType
          ? ` across ${integrationType.toLowerCase()} properties`
          : ''}
        .
      </Typography>
      <Button
        size="small"
        sx={{
          whiteSpace: 'nowrap',
          minWidth: 'max-content',
        }}
        onClick={onClickAddIntegration}
      >
        Add {integrationType} Integration
      </Button>
    </Stack>
  );
};
